import React from 'react';

const formatCurrency = (value) => {
  if (value == null || isNaN(value)) return '$0';
  return `$${Number(value).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
};

const GoldInvestmentExecSummary = ({ investorResult, yearlyData, params }) => {
  if (!investorResult || !yearlyData || !params) {
    return <div className="text-center text-gray-500">No data available.</div>;
  }

  const finalYear = yearlyData[yearlyData.length - 1];

  return (
    <div className="bg-yellow-50 p-6 rounded-lg text-sm text-gray-800 leading-relaxed space-y-4">
      <h3 className="text-lg font-bold text-yellow-900">Executive Summary: Gold Accumulation Model</h3>

      <p>
        This <strong>Gold Investment</strong> simulation models a long-term accumulation strategy over a {params.termYears}-year period,
        where an investor starts with an initial purchase of <strong>{formatCurrency(params.propertyValue)}</strong> worth of gold and
        contributes an additional <strong>{formatCurrency(params.monthlyInvestmentAmount)}</strong> each month, based on the prevailing gold price.
      </p>

      <p>
        Over time, the investor accumulates physical gold monthly, taking advantage of compounding price growth at an average
        rate of <strong>{params.goldGrowthRate}% annually</strong>. By the end of the term, this disciplined approach results in both a
        significantly larger gold reserve and a high-value exit.
      </p>

      <h4 className="font-semibold text-yellow-800">📈 Key Performance Highlights</h4>
      <ul className="list-disc list-inside space-y-1">
        <li>Total Term: <strong>{params.termYears} years</strong> ({params.termYears * 12} months)</li>
        <li>Initial Investment: <strong>{formatCurrency(params.propertyValue)}</strong></li>
        <li>Monthly Contribution: <strong>{formatCurrency(params.monthlyInvestmentAmount)}</strong></li>
        <li>Total Investment Over Time: <strong>{formatCurrency(investorResult.totalInvestment)}</strong></li>
        <li>Total Gold Accumulated: <strong>{investorResult.totalGoldAccumulated} g</strong></li>
        <li>Final Gold Price: <strong>{formatCurrency(investorResult.goldPriceAtEnd)}</strong></li>
        <li>Final Portfolio Value: <strong>{formatCurrency(investorResult.finalValue)}</strong></li>
        <li>Net Profit: <strong>{formatCurrency(investorResult.finalNetProfit)}</strong></li>
        <li>Total ROI: <strong>{investorResult.totalROI}%</strong></li>
        <li>Annualized ROI: <strong>{investorResult.annualizedROI}%</strong></li>
        <li>IRR Estimate: <strong>{investorResult.irrEstimate}%</strong></li>
      </ul>

      <p>
        This model is ideal for conservative investors seeking a long-term hedge against inflation, currency devaluation,
        or economic volatility — while consistently building a tangible, appreciating asset.
      </p>
    </div>
  );
};

export default GoldInvestmentExecSummary;
